import ErrorModal from "components/Modals/ErrorModal.tsx";
import SendToOpsModal from "pages/tasks/components/modals/SendToOpsModal";
import TaskModal from "pages/tasks/components/modals/TaskModal";

type TaskBoardModalsProps = {
  errors: string[];
  onCloseErrorModal: () => void;
  onCloseSendToOpsModal: () => void;
  onCloseTaskModal: () => void;
  showErrorModal: boolean;
  showSendToOpsModal: boolean;
  showTaskModal: boolean;
};

/* render all task-board modal variants in one place.
   keeps the board container focused on lane rendering and data flow. */
export const TaskBoardModals = ({
  errors,
  onCloseErrorModal,
  onCloseSendToOpsModal,
  onCloseTaskModal,
  showErrorModal,
  showSendToOpsModal,
  showTaskModal,
}: TaskBoardModalsProps) => {
  return (
    <>
      <SendToOpsModal
        isOpen={showSendToOpsModal}
        onClose={onCloseSendToOpsModal}
      />
      <TaskModal isOpen={showTaskModal} onClose={onCloseTaskModal} />
      <ErrorModal
        isOpen={showErrorModal}
        onClose={onCloseErrorModal}
        message="Failed to change task status"
        errors={errors}
      />
    </>
  );
};

export default TaskBoardModals;
